module.exports = __webpack_public_path__ + "img/symbol-lens-signature-eg.a4c680e8.svg";